export default __webpack_public_path__ + "static/media/give-yourself-a-break.bfc2c398.md";